<template>
  <div class="_box">
    <gTimeComp type="today" :sTime.sync="startTime" :eTime.sync="endTime" @click="timeChange"></gTimeComp>
    <gLine></gLine>
    <div class="p-32 bg-white " v-if="itemList.length > 0">
      <div class="f btn_box">
        <div v-for="(v, i) in btnList" :key="i" class="btn_item">
          <gBtn :title="v.clocktype + ': ' + v.count" :active="v.active" @click="btnClick(v.clocktype, i)" width="60">
          </gBtn>
        </div>
      </div>

      <div class="item_box">
        <div v-for="(v, i) in itemList" :key="i" class="item_list p-tb-20">
          <div class="time_box f-bt">
            <div class="f-3 h-block f-cl">
              <div class="f">
                <div class="m-r-10 circle f-ar" v-clockBg="v.clocktype">
                  {{ v.clocktype.slice(0, 1) }}
                </div>
                <div>{{ $pub.hideMiddelTxt(v.project) }}</div>
                <div v-if="v.ischeckout" class="checkout_tag">已结账</div>
              </div>
            </div>
            <div class="cl-99 ft-20 f-2 tr">
              {{ handleTime(v.starttime, v.endtime) }}
            </div>
          </div>

          <div class="f-bt m-t-10">
            <div class="m-r-20" v-if="!isDisableJishiPersumeInfo">
              <span class="cl-99">项目提成 </span>
              <span>{{ v.persume | toMoney }}</span>
            </div>
            <div>
              <span class="cl-99">加班补贴 </span>
              <span>{{ v.allowance | toMoney }}</span>
            </div>
            <div class="ft-20 f-2 tr">
              <span class="cl-99">钟数: </span>
              <span>{{ v.numbercount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <gNoContent v-if="itemList.length === 0" title="暂无做钟数据"></gNoContent>

    <gLogoBottom></gLogoBottom>
  </div>
</template>

<script>

import { getPersumestatistics, getClockstatistics, getJishicode, jishiDuty } from "@/api/Jishi";

export default {
  name: "JiShiClockDetail",
  props: {},
  data() {
    return {
      startTime: "",
      endTime: "",
      aData: {},
      btnList: [],
      originItemList: [],
      itemList: [],
      isDisableJishiPersumeInfo: false
    };
  },
  computed: {},
  components: {},
  created() {
    // clockHttp(this,this.startTime, this.endTime);
  },
  mounted() {
    this.getSetting();
    this.timeChange()
  },
  methods: {
    getSetting() {
      // 获取后台参数--是否禁用技师查看提成功能
      // postParameterSetting().then(res => {
      //   this.isDisableJishiPersumeInfo = res.DisableJishiViewPersume;
      // });
    },
    timeChange() {
      let  getVpnId = ''
      const preStoreInfo = localStorage.getItem("store");
      if (preStoreInfo) {
        getVpnId = JSON.parse(preStoreInfo).vpnId;
      }

      let originParams = {
        Pager: {
          PageIndex: 0,
          PageSize: 100,
        },
        JiShiCode: '065',  //temporaryStorage.get('jsCode'), // 技师或服务员编号
        StartTime: this.startTime,
        EndTime: this.endTime,
        VpnId:getVpnId,
        ClockType: '',
      }

      getClockstatistics(originParams).then(res => {
        this.aData = res.data;
        const all = [
          { count: this.aData.clocktotalcount, clocktype: "全部", active: true }
        ];
        this.btnList = all.concat(this.aData.lst_clock_total);
        this.originItemList = res.data.lst_clock_history;

        // this.originItemList = this.originItemList.concat(this.originItemList).concat(this.originItemList).concat(this.originItemList).concat(this.originItemList).concat(this.originItemList).concat(this.originItemList).concat(this.originItemList)
        this.itemList = this.$pub.deepClone(this.originItemList);

      })
    },
    // 处理时间
    handleTime(start, end) {
      const getStart = this.$pub.parseTime(start, "{y}/{m}/{d} {h}:{i}");
      const getEnd = this.$pub.parseTime(end, "{y}/{m}/{d} {h}:{i}");
      const res =
        getStart.split(" ")[1] +
        "~" +
        getEnd.split(" ")[1] +
        "     " +
        getStart.split(" ")[0];
      return res;
    },
    btnClick(v, i) {
      this.btnList = this.btnList.map((val, idx) => {
        val.active = false;
        if (idx === i) {
          val.active = true;
        }
        return val;
      });
      if (v === "全部") {
        this.itemList = this.$pub.deepClone(this.originItemList);
      } else {
        this.itemList = this.originItemList.filter(val => {
          return val.clocktype === v;
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.btn_box {
  flex-wrap: wrap;

  .btn_item {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.item_box {
  color: #333;
  padding: 10px 0;
  font-size: 24px;
  min-height: calc(100vh - 300px);

  .item_list {
    border-bottom: 1px solid #ebedf0;
    height: 136px;
    box-sizing: border-box;
  }
}

.circle {
  border-radius: 50%;
  color: #fff;
  width: 30px;
  height: 30px;
  font-size: 20px;
  padding: 8px;
  margin-right: 20px;
}

.time_box {
  display: flex;
  align-items: center;

  .checkout_tag {
    padding: 3px 6px;
    margin-left: 10px;
    color: #fff;
    background: var(--themeColor);
    height: 28px;
    line-height: 28px;
    font-size: 22px;
    border-radius: 8px 0 8px 0;
  }
}

// ._box {
//   box-sizing: border-box;
//   margin-bottom: 80px;
//   position: relative;
// }
</style>
